import React from 'react';
import reactDOM from 'react-dom';
import { bemClasses } from 'general/js/modal';
import { ReactModal } from 'components/modal';
import EndeavorPlayer from '../../endeavor-player/js/components/endeavor-player';

class EndeavorPlayerModal {
    constructor() {
        this.root = document.createElement('div');
        this.root.id = 'endeavor-player-modal';
        document.body.appendChild(this.root);

        this.modal = null;
        this.state = {
            videoId: null,
            options: {},
            seoUrl: null,
        };
    }

    destroy() {
        reactDOM.unmountComponentAtNode(this.root);
    }

    show = (videoId, options = {}, seoUrl) => {
        if (typeof videoId !== 'string') return;

        this.state.videoId = videoId;
        this.state.options = options;
        this.state.seoUrl = seoUrl;
        this.render();
    }

    hide = () => {
        this.state.videoId = null;
        this.state.options = {};
        this.state.videos = {};

        if (this.state.seoUrl !== null && this.state.seoUrl !== undefined && this.state.seoUrl.trim() !== '') {
            window.history.back();
        }

        this.state.seoUrl = null;
        this.state.cloudVideo = null;
        this.render();
    }

    render() {
        const { videoId, options } = this.state;
        const model = {
            ...options,
            videoId,
        };
        const modalOptions = {
            bemList: [bemClasses.WIDE]
        };

        reactDOM.render(
            <ReactModal
                options={modalOptions}
                isOpen={!!videoId}
                onCloseCb={this.hide}
            >
                {
                    !!videoId &&
                    <EndeavorPlayer {...model} />
                }
            </ReactModal>,
            this.root
        );
    }
}

export default new EndeavorPlayerModal();
